export default __webpack_public_path__ + "static/media/hbs-bpk-poster-3.7bc1c7c9.jpg";